import { lazy } from "react";
import { useRoutes } from "react-router-dom";

// project imports
import Loadable from "ui-component/Loadable";

// routes
import MainRoutes from "./MainRoutes";
const Error = Loadable(lazy(() => import("views/pages/maintenance/Error")));

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([MainRoutes, { path: "*", element: <Error /> }]);
}
